/**
 * Подписи просмотра трансляции: как назвать чужой экран и какое у него качество.
 * Чистые функции без сторов — проверяются в scripts/stream-view.test.mjs.
 */
import { heightLabel } from './screenShare'

/** Подпись трансляции там, где рядом нет самого человека: плитка, шапка просмотра, окно поверх. */
export function streamLabel(name: string): string {
  return `Экран ${name}`
}

/** Ступени частоты кадров из окна выбора качества (см. SHARE_FPS). */
const FPS_STEPS = [15, 30, 60]

/**
 * Короткая подпись качества для шапки просмотра: «1080p 60 к/с». Считается по тому, что реально
 * приходит, а не по выбору показывающего: его зритель не знает. Кадры в пределах трёх от ступени
 * прижимаем к ней — иначе подпись дрожала бы между 29, 30 и 31 каждую секунду; точные цифры
 * остаются в «Цифрах трансляции».
 */
export function qualityLabel(height: number, fps: number): string | null {
  if (!height) return null
  const res = heightLabel(height)
  if (!fps) return res
  const step = FPS_STEPS.find((f) => Math.abs(f - fps) <= 3)
  return `${res} ${step ?? Math.round(fps)} к/с`
}
